module.exports = {
	"selectedStates": {},
	"brokerInformation": {
		"state": "",
		"gender": null,
		"brokerLicenses": [],
		"federalMarketplaceUserID": "",
		"medicaQualified": false
	},
	"agencyInformation": {
		"businessState": "",
		"taxClassification": null,
		"agencyLicenses": [],
		"usingAgency": false,
		"generalAgencyName": ""
	},
	"commissionInformation": {
		"assignee": "myself",
		"sameAsAgency": false,
		"assigneeState": ""
	},
	"declarations": {
		"questionsAndResponses": {
			"A": {
				"question": "Have you, or an organization over which you exercised management or policy control, ever:",
				"response": false,
				"explanation": "",
				"subQuestions": {
					"1": {
						"question": "Declared bankruptcy, filed a bankruptcy petition or been declared bankrupt?",
						"response": false,
						"explanation": ""
					},
					"2": {
						"question": "Had earnings garnished?",
						"response": false,
						"explanation": ""
					},
					"3": {
						"question": "Made a compromise with creditors?",
						"response": false,
						"explanation": ""
					},
					"4": {
						"question": "Been charged with a felony or misdemeanor (including petty misdemeanors within the last 10 years) in a domestic or foreign court?",
						"response": false,
						"explanation": ""
					}
				}
			},
			"B": {
				"question": "Do you have any satisfied or unsatisfied judgments or liens against you?",
				"response": false,
				"explanation": "",
				"subQuestions": null
			},
			"C": {
				"question": "Has a bonding company denied, paid out or revoked a bond for you?",
				"response": false,
				"explanation": "",
				"subQuestions": null
			},
			"D": {
				"question": "Have you ever voluntarily or involuntarily surrendered any professional license?",
				"response": false,
				"explanation": "",
				"subQuestions": null
			},
			"E": {
				"question": "Has any federal regulatory agency or any state regulatory agency ever:",
				"response": false,
				"explanation": "",
				"subQuestions": {
					"1": {
						"question": "Found you to have made a false statement or omission or been dishonest, unfair or unethical?",
						"response": false,
						"explanation": ""
					},
					"2": {
						"question": "Found you to have been involved in violation of regulations or statutes?",
						"response": false,
						"explanation": ""
					},
					"3": {
						"question": "Found you to have been a cause of a business having its authorization to do business denied, suspended, revoked or restricted?",
						"response": false,
						"explanation": ""
					},
					"4": {
						"question": "Denied, suspended or revoked your registration or license, or otherwise prevented you from associating with any business or disciplined you by restricting your activities?",
						"response": false,
						"explanation": ""
					}
				}
			},
			"F": {
				"question": "Have you ever had a complaint filed against you involving insurance products or securities?",
				"response": false,
				"explanation": "",
				"subQuestions": null
			},
			"G": {
				"question": "Have you ever been involved with, or a party to, any litigation with any insurance company or any entity which is engaged in the sale, marketing or administration of insurance or securities?",
				"response": false,
				"explanation": "",
				"subQuestions": null
			},
			"H": {
				"question": "Have you ever been involved with, or a party to, any litigation which involved issues of misrepresentation, fraud, or misappropriation of funds?",
				"response": false,
				"explanation": "",
				"subQuestions": null
			},
			"I": {
				"question": "Have you ever been discharged or permitted to resign because you were accused of:",
				"response": false,
				"explanation": "",
				"subQuestions": {
					"1": {
						"question": "Violating investment or insurance related statutes, regulations, rules or industry standards of conduct?",
						"response": false,
						"explanation": ""
					},
					"2": {
						"question": "Fraud or the wrongful taking of property?",
						"response": false,
						"explanation": ""
					},
					"3": {
						"question": "Failure to supervise in connection with investment or insurance-related statutes,regulations, rules or industry standards of conduct?",
						"response": false,
						"explanation": ""
					}
				}
			},
			"J": {
				"question": "Are you now the subject of any complaint, investigation or proceeding that could result in a 'Yes'; answer to any part of this questionnaire?",
				"response": false,
				"explanation": "",
				"subQuestions": null
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/js/data/formStarterData.json
// module id = 38
// module chunks = 0